import { ServiceBundleModel } from './ServiceBundleModel';
import { RequestModel } from './RequestModel';
import { Bundle } from '../enums/v2/Bundle';
export class AppModel {
    constructor(app) {
        this.name = app.name;
        this.uuid = app.uuid;
        this.merchantType = app.merchantType;
        this.activePagePhotoUrl = app.activePagePhotoUrl;
        this.bundle = new ServiceBundleModel(app.serviceBundle);
        this.request = new RequestModel(app.request);
        this.active = app.active;
        this.deactivated = app.deactivated;
        this.launchedAt = app.launchedAt;
        this.storeStatus = app.storeStatus;
        this.maintenance = app.maintenance;
        this.activePage = app.activePage;
    }
    get isAffiliate() {
        return this.bundle.key === Bundle.Affiliate;
    }
    get isMerchant() {
        return this.merchantType === 'merchant';
    }
    get isTenant() {
        return this.merchantType === 'tenant';
    }
    get isDistributor() {
        return this.merchantType === 'distributor';
    }
    get deleteable() {
        return true; // allow all apps to be deleted
        // return this.isMerchant && !this.activePagePhotoUrl && this.request.status === 'pending';
    }
    get isUnfinishedDiyApp() {
        return this.isMerchant && this.request.status === 'pending';
    }
}
